import { ErrorScreen } from '@eureca/ui';
import { TriangleAlertIcon, WifiOffIcon } from '@eureca/ui/icons';
import { GRAVE_ERROR, NO_CONNECTION } from './messages';

/** Erro grave do fluxo — Figma 20186:22986 (sem header). */
export function GraveErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <ErrorScreen
      testId="alignment-grave-error"
      tone="muted"
      icon={<TriangleAlertIcon className="size-7 text-foreground" />}
      title={GRAVE_ERROR.title}
      body={GRAVE_ERROR.body}
      primary={{ label: GRAVE_ERROR.retry, onClick: onRetry }}
    />
  );
}

/** Sem conexão — Figma 20186:22985 (sem header). */
export function NoConnectionScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <ErrorScreen
      testId="alignment-no-connection"
      tone="muted"
      icon={<WifiOffIcon className="size-7 text-foreground" />}
      title={NO_CONNECTION.title}
      body={NO_CONNECTION.body}
      primary={{ label: NO_CONNECTION.retry, onClick: onRetry }}
    />
  );
}
